import _regeneratorRuntime from "/usr/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import Progress from "@componentsShared/Tailwind/Progress/Progress";
import Layout from "@/_LayoutsRelated/layout/Layout";
import ScreenMainCard from "./ScreenMainCard";
import { useDynamicForm } from "@/pages/finance-eligibility/context/ScreenContext";
import StepperHeader from "@/pages/finance-eligibility/components/StepperHeader";
import ConfirmationModal from "@componentsShared/Confirmation/ConfirmationModal";
import { useTranslation } from "@i18n";
import { useConfirmation } from "@hooks/useConfirmation";
import { AuthPopupHOC } from "@/_MiniApps/auth/AuthContext";
import ScreenButton from "@/pages/finance-eligibility/components/ScreenButton";
import { useMemo } from "react";
import banners from "@data/banners/login-pages/saved_search.json";
import { useLang } from "@/common/Contexts/LanguageContext";
import { useCMS } from "@hooks/useCMS";
import AnimatedCard from "@/pages/finance-eligibility/components/AnimatedCard";
import useHelpers from "@hooks/useHelpers";
import { trackEvents } from "@/common/events/events";
import useDirection from "@hooks/useDirection";
import useIsMobile from "@hooks/useIsMobile";
import stl from "@componentsShared/buts/SubmitButton/SubmitButton.module.css";
var TransitionScreen = function TransitionScreen(_ref) {
  var screenData = _ref.screenData,
    handleScreenNextButton = _ref.handleScreenNextButton,
    isFormValid = _ref.isFormValid,
    isSubmitting = _ref.isSubmitting;
  var _useDynamicForm = useDynamicForm(),
    currentStep = _useDynamicForm.currentStep;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var lang = useLang();
  var direction = useDirection();
  var _useCMS = useCMS(),
    imageUrl = _useCMS.imageUrl;
  var _useConfirmation = useConfirmation(),
    confirmationHandlers = _useConfirmation.confirmationHandlers,
    confirmation = _useConfirmation.confirmation,
    awaitConfirmation = _useConfirmation.awaitConfirmation;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var isMobile = useIsMobile();
  var layoutOptions = {
    hideOrangeHeadBtn: true,
    hideFooter: true,
    hideSideMenue: false,
    hideAppBanner: true,
    mobileNoLogo: true,
    hideHeaderOnmobile: true,
    headHideLinks: true,
    custommobileHeader: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StepperHeader, null))
  };
  var authScreenDesign = useMemo(function () {
    return {
      banners: {
        desktop: imageUrl(banners[lang].desktop_images[0]),
        mobile: imageUrl(banners[lang].mobile_images[0])
      },
      title: t("تسجيل دخول/إنشاء حساب", {
        ns: "web_common"
      }),
      description: t("قم بتسجيل الدخول/ إنشاء حساب الآن لمعرفة ما إذا كنت مؤهلًا للحصول على التمويل", {
        ns: "web_common"
      })
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout, layoutOptions, /*#__PURE__*/React.createElement("div", {
    className: "lg:before:content-[''] lg:before:block lg:before:h-[340px] lg:before:bg-white lg:before:absolute lg:before:top-0 lg:before:left-0 lg:before:w-full lg:before:z-[1] lg:min-h-[calc(100vh-41px)] xl:min-h-[100vh-72px] lg:bg-[#FAFCFF]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lg:max-w-[665px] mx-auto lg:pt-14 lg:z-[2] relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center mb-8"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-primary text-2xl font-bold"
  }, currentStep === null || currentStep === void 0 ? void 0 : currentStep.main_title), /*#__PURE__*/React.createElement("button", {
    className: "cursor-pointer py-2 px-6 text-gray-text text-sm font-semibold bg-white border border-solid border-gray-gainsboro rounded",
    type: "button",
    onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var isConfirmed;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return awaitConfirmation();
          case 2:
            isConfirmed = _context.sent;
            if (isConfirmed) {
              sessionStorage.removeItem("eligibility_data");
              sessionStorage.removeItem("submission_source");
              trackEvents("eligibility_check_cancel", {
                question_id: currentStep === null || currentStep === void 0 ? void 0 : currentStep.id
              });
              history.back();
            } else {
              confirmation.setFalse();
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))
  }, t("إلغاء", {
    ns: "web_common"
  })))), isMobile ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "py-4 px-3 lg:bg-white lg:p-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6 lg:gap-10 lg:px-16 lg:pt-12 lg:pb-16 lg:border lg:border-solid lg:border-gray-gainsboro lg:rounded-2xl lg:shadow-xl"
  }, /*#__PURE__*/React.createElement(Progress, {
    value: screenData === null || screenData === void 0 ? void 0 : screenData.progress_bar,
    max: 100,
    id: "progress",
    direction: direction
  }), /*#__PURE__*/React.createElement("div", {
    className: "lg:flex lg:flex-col lg:py-8 lg:px-6 lg:rounded-lg lg:border lg:border-solid lg:border-gray-gainsboro"
  }, /*#__PURE__*/React.createElement(ScreenMainCard, {
    screenData: screenData
  }), (currentStep === null || currentStep === void 0 ? void 0 : currentStep.next_text) && /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:mt-6 lg:block lg:w-[172px] lg:ms-auto"
  }, /*#__PURE__*/React.createElement(AuthPopupHOC, {
    customModalClassName: "modalHideHeader",
    authScreenDesign: authScreenDesign,
    renderFunc: function renderFunc(checkAuth) {
      return /*#__PURE__*/React.createElement(ScreenButton, {
        onClick: function onClick() {
          return handleScreenNextButton(checkAuth);
        },
        disabled: !isFormValid,
        className: isSubmitting ? "pointer-events-none" : ""
      }, isSubmitting ? /*#__PURE__*/React.createElement("span", {
        className: stl.loader
      }) : currentStep.next_text);
    },
    onCancel: function onCancel() {
      trackEvents("element_click", {
        element_name: "eligibility",
        user_login_status: "false"
      });
    }
  })))))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AnimatedCard, {
    key: screenData === null || screenData === void 0 ? void 0 : screenData.key
  }, /*#__PURE__*/React.createElement("div", {
    className: "py-4 px-3 lg:bg-white lg:p-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6 lg:gap-10 lg:px-16 lg:pt-12 lg:pb-16 lg:border lg:border-solid lg:border-gray-gainsboro lg:rounded-2xl lg:shadow-xl"
  }, /*#__PURE__*/React.createElement(Progress, {
    value: screenData === null || screenData === void 0 ? void 0 : screenData.progress_bar,
    max: 100,
    id: "progress",
    direction: direction
  }), /*#__PURE__*/React.createElement("div", {
    className: "lg:flex lg:flex-col lg:py-8 lg:px-6 lg:rounded-lg lg:border lg:border-solid lg:border-gray-gainsboro"
  }, /*#__PURE__*/React.createElement(ScreenMainCard, {
    screenData: screenData
  }), (currentStep === null || currentStep === void 0 ? void 0 : currentStep.next_text) && /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:mt-6 lg:block lg:w-[172px] lg:ms-auto"
  }, /*#__PURE__*/React.createElement(AuthPopupHOC, {
    customModalClassName: "modalHideHeader",
    authScreenDesign: authScreenDesign,
    renderFunc: function renderFunc(checkAuth) {
      return /*#__PURE__*/React.createElement(ScreenButton, {
        onClick: function onClick() {
          return handleScreenNextButton(checkAuth);
        },
        disabled: !isFormValid,
        className: isSubmitting ? "pointer-events-none" : ""
      }, isSubmitting ? /*#__PURE__*/React.createElement("span", {
        className: stl.loader
      }) : currentStep.next_text);
    },
    onCancel: function onCancel() {
      trackEvents("element_click", {
        element_name: "eligibility",
        user_login_status: "false"
      });
    }
  })))))))), /*#__PURE__*/React.createElement(ConfirmationModal, {
    variant: "default",
    title: t("هل انت متأكد من الإلغاء", {
      ns: "web_common"
    }),
    isOpen: confirmation.value,
    cancelText: t("متابعة الطلب", {
      ns: "web_common"
    }),
    confirmText: t("إلغاء الطلب", {
      ns: "web_common"
    }),
    onClose: function onClose() {
      return confirmationHandlers === null || confirmationHandlers === void 0 ? void 0 : confirmationHandlers.handleCancel();
    },
    onConfirm: function onConfirm() {
      return confirmationHandlers === null || confirmationHandlers === void 0 ? void 0 : confirmationHandlers.handleConfirm();
    }
  }))));
};
export default TransitionScreen;